import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PromoSection = () => {
  const navigate = useNavigate();

  return (
    <section id="promo-pricing-section" className="py-12 px-4 bg-gradient-to-br from-orange-50 via-white to-green-50">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-10">
          <div className="inline-block px-4 py-2 bg-gradient-to-r from-orange-500 to-orange-600 text-white text-lg font-bold rounded-full mb-4 shadow-lg">
🌞 OFFRE ÉTÉ 2026
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
Offres exceptionnelles valables jusqu'en septembre 2026
          </h2>
          <p className="text-lg text-gray-600">
            Profitez de nos tarifs promotionnels pour vos envois vers Abidjan
          </p>
        </div>

        {/* MAIN OFFER - Dominant Card */}
        <div className="mb-8">
          <div className="relative bg-gradient-to-br from-green-50 to-white border-4 border-green-500 rounded-2xl p-8 shadow-2xl transform hover:scale-[1.02] transition-transform duration-300">
            {/* Premium Badge */}
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
              <div className="bg-green-600 text-white px-6 py-2 rounded-full font-bold text-sm shadow-lg">
                ⭐ OFFRE PRINCIPALE
              </div>
            </div>

            {/* Glow Effect */}
            <div className="absolute inset-0 bg-green-400 opacity-20 blur-xl rounded-2xl"></div>

            <div className="relative z-10">
              {/* Title */}
              <div className="text-center mb-6">
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2 flex items-center justify-center gap-2 flex-wrap">
                  <span className="text-3xl">🎁</span>
                  <span>Barrique noire 270L OFFERTE</span>
                </h3>
                <p className="text-lg text-green-700 font-semibold">
                  Offre Été 2026 : Barrique noire 270L OFFERTE + transport complet France → Abidjan
                </p>
              </div>

              {/* Price Section */}
              <div className="text-center mb-6">
                <div className="inline-block">
                  <div className="text-6xl md:text-7xl font-black text-green-600 mb-2">
                    160€
                    <span className="text-2xl md:text-3xl font-semibold text-gray-600 ml-2">TTC</span>
                  </div>
                  <div className="text-sm text-green-700 font-medium">
                    Tout compris — barrique noire 270L offerte + transport complet
                  </div>
                </div>
              </div>

              {/* Benefits Grid */}
              <div className="grid md:grid-cols-2 gap-4 mb-6">
                <div className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm">
                  <Icon name="CheckCircle" className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="font-semibold text-gray-900">Barrique noire 270L incluse</p>
                    <p className="text-sm text-gray-600">Valeur 30€ offerte</p>
                  </div>
                </div>
                <div className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm">
                  <Icon name="CheckCircle" className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="font-semibold text-gray-900">Transport maritime Paris → Abidjan</p>
                    <p className="text-sm text-gray-600">Service complet inclus</p>
                  </div>
                </div>
                <div className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm">
                  <Icon name="CheckCircle" className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="font-semibold text-gray-900">Livraison incluse à Abidjan</p>
                    <p className="text-sm text-gray-600">Jusqu'à votre porte</p>
                  </div>
                </div>
                <div className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm">
                  <Icon name="CheckCircle" className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="font-semibold text-gray-900">Paiement flexible 60/40</p>
                    <p className="text-sm text-gray-600">Facilité de paiement</p>
                  </div>
                </div>
              </div>

              {/* CTA Button */}
              <div className="text-center">
                <Button
                  onClick={() => navigate('/commander')}
                  className="bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white px-10 py-4 rounded-xl font-bold text-lg shadow-xl transition-all duration-300 transform hover:scale-105"
                >
                  <span className="flex items-center gap-2">
                    <Icon name="Gift" className="w-5 h-5" />
                    Profiter de l'offre avec barrique offerte
                  </span>
                </Button>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Info */}
        <div className="mt-8 text-center">
          <div className="inline-flex items-center gap-2 text-gray-600 bg-white px-6 py-3 rounded-full shadow-md">
            <Icon name="Clock" className="w-5 h-5 text-orange-600" />
            <span className="font-medium">
Offre valable jusqu'en <strong className="text-orange-600">septembre 2026</strong>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromoSection;